import { IconButton } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";

export const LogoutButton = ({ onClick }: any) => {
  return (
    <IconButton
      style={{ color: "#EB4C43" }}
      aria-label="logout"
      onClick={onClick}>
      <LogoutIcon />
    </IconButton>
  );
};
